import axios from 'axios';

export const validateRecaptchaToken = async ({
  token,
  recaptchaToken
}: {
  token: string;
  recaptchaToken: string;
}): Promise<any> => {
  const URL = `${
    process.env.NEXT_PUBLIC_WP_API_URL || process.env.WP_API_URL
  }/v1/contact-forms/recaptcha`;

  const config = {
    headers: {
      ['UYN-BEARER']: token
    },
    params: {
      token: recaptchaToken
    }
  };

  return axios.post(URL, null, config);
};
